exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-pc-components-molecules-QuestionTitle-___QuestionTitle__title___9Ma27 {\n  border-bottom: 2px solid #50e6a7;\n}\n", ""]);

// exports
exports.locals = {
	"title": "src-pc-components-molecules-QuestionTitle-___QuestionTitle__title___9Ma27"
};